// =========================================================================
// Build-time 注入された engine metadata の薄いラッパー
// =========================================================================
// vite.config.ts で define されている __ENGINE_VERSION__ / __ENGINE_PACKAGE_NAME__
// を型安全に参照するためのモジュール。runtime で engine の package.json を
// 直接 import しないようにするための「窓」 (Node Built-in 混入の予防)。
// =========================================================================

declare const __ENGINE_VERSION__: string;
declare const __ENGINE_PACKAGE_NAME__: string;

export const env = {
  engineVersion: __ENGINE_VERSION__,
  engineName: __ENGINE_PACKAGE_NAME__,
} as const;
